import { Link } from 'react-router-dom';

const styles = {
  wrap: {
    minHeight: '100vh',
    background: '#fafaf9',
    padding: '2rem 1rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: '#1a1a1a',
    lineHeight: 1.6
  },
  card: {
    maxWidth: '720px',
    margin: '0 auto',
    background: '#fff',
    padding: '2.5rem',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  },
  back: {
    fontSize: '13px',
    color: '#7c3aed',
    textDecoration: 'none',
    fontWeight: 500,
    display: 'inline-block',
    marginBottom: '1.5rem'
  },
  h1: {
    fontSize: '28px',
    fontWeight: 700,
    margin: '0 0 8px',
    letterSpacing: '-0.025em',
    color: '#0a0a0c'
  },
  meta: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '2rem'
  },
  intro: {
    fontSize: '15px',
    color: '#333',
    marginBottom: '2rem',
    padding: '1rem',
    background: '#f9f7ff',
    borderLeft: '3px solid #7c3aed',
    borderRadius: '4px'
  },
  h2: {
    fontSize: '17px',
    fontWeight: 600,
    margin: '1.75rem 0 0.75rem',
    color: '#0a0a0c',
    letterSpacing: '-0.01em'
  },
  p: {
    fontSize: '14px',
    color: '#333',
    margin: '0.5rem 0',
    lineHeight: 1.6
  },
  ul: {
    fontSize: '14px',
    color: '#333',
    paddingLeft: '1.25rem',
    margin: '0.5rem 0',
    lineHeight: 1.7
  }
};

export default function PrivacyPolicy() {
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <Link to="/" style={styles.back}>← Powrót</Link>

        <h1 style={styles.h1}>Polityka Prywatności</h1>
        <p style={styles.meta}>Serwis file.mtcapital.pl · Ostatnia aktualizacja: czerwiec 2026</p>

        <p style={styles.intro}>
          Niniejsza polityka określa zasady przetwarzania danych osobowych użytkowników
          serwisu file.mtcapital.pl służącego do bezpiecznego udostępniania plików między
          MT Capital sp. z o.o. a jej klientami.
        </p>

        <h2 style={styles.h2}>1. Administrator danych</h2>
        <p style={styles.p}>
          Administratorem Państwa danych osobowych jest <strong>MT Capital Sp. z o.o.</strong>
          z siedzibą przy ul. Dworska 7/1, 40-584 Katowice, wpisaną do rejestru przedsiębiorców KRS pod numerem
          000615119, NIP: 634 286 24 52, REGON: 364 311 028.
        </p>
        <p style={styles.p}>
          <strong>Kontakt w sprawach ochrony danych:</strong> biuro@mtcapital.pl
        </p>

        <h2 style={styles.h2}>2. Inspektor Ochrony Danych</h2>
        <p style={styles.p}>
          We wszystkich sprawach dotyczących ochrony danych osobowych prosimy o kontakt na adres
          podany w punkcie 1. W przypadku wyznaczenia Inspektora Ochrony Danych, jego dane
          kontaktowe zostaną podane w aktualizacji niniejszej polityki.
        </p>

        <h2 style={styles.h2}>3. Zakres przetwarzanych danych</h2>
        <p style={styles.p}>Podczas korzystania z serwisu przetwarzamy następujące dane:</p>
        <ul style={styles.ul}>
          <li>Adres IP urządzenia, z którego nastąpił dostęp</li>
          <li>Typ przeglądarki i systemu operacyjnego (User-Agent)</li>
          <li>Data i godzina pobrania pliku</li>
          <li>Adres email (jeśli został podany przez nadawcę lub Państwa)</li>
          <li>Imię i nazwisko (w nazwach plików lub folderów, jeśli zostały tam zawarte)</li>
          <li>Treść przekazywanych dokumentów (mogą zawierać Państwa dane osobowe)</li>
        </ul>

        <h2 style={styles.h2}>4. Cele i podstawa prawna przetwarzania</h2>
        <p style={styles.p}>Dane przetwarzane są w następujących celach:</p>
        <ul style={styles.ul}>
          <li>
            <strong>Realizacja umowy</strong> (Art. 6 ust. 1 lit. b RODO) — dostarczanie
            dokumentów i świadczenie usług inwestycyjnych
          </li>
          <li>
            <strong>Wypełnienie obowiązku prawnego</strong> (Art. 6 ust. 1 lit. c RODO) —
            przechowywanie dokumentacji wynikające z przepisów o przeciwdziałaniu praniu
            pieniędzy (AML), MIFID II oraz wymagań Komisji Nadzoru Finansowego
          </li>
          <li>
            <strong>Prawnie uzasadniony interes administratora</strong> (Art. 6 ust. 1 lit. f RODO) —
            prowadzenie audit log dla celów bezpieczeństwa, wykrywania nadużyć i zapewnienia
            ciągłości działania
          </li>
        </ul>

        <h2 style={styles.h2}>5. Okres przechowywania</h2>
        <ul style={styles.ul}>
          <li><strong>Logi dostępu i audit log:</strong> 12 miesięcy od daty zdarzenia</li>
          <li><strong>Pliki udostępnione:</strong> zgodnie z ustawieniami nadawcy (do daty wygaśnięcia linku)</li>
          <li><strong>Dokumentacja AML/KYC:</strong> 5 lat po zakończeniu relacji biznesowej (Ustawa AML)</li>
          <li><strong>Dokumentacja transakcyjna MIFID II:</strong> 5-7 lat (Rozporządzenie delegowane 2017/590)</li>
          <li><strong>Konta użytkowników:</strong> przez okres obowiązywania relacji biznesowej oraz okres dochodzenia roszczeń</li>
        </ul>

        <h2 style={styles.h2}>6. Odbiorcy danych</h2>
        <p style={styles.p}>Państwa dane mogą być przekazywane:</p>
        <ul style={styles.ul}>
          <li>Dostawcom infrastruktury IT (Railway Corp. jako podmiot przetwarzający na podstawie umowy DPA)</li>
          <li>Organom państwowym na podstawie obowiązujących przepisów prawa (KNF, GIIF, organy ścigania)</li>
          <li>Podmiotom świadczącym usługi prawne i audytorskie na rzecz administratora</li>
        </ul>

        <h2 style={styles.h2}>7. Przekazywanie danych poza EOG</h2>
        <p style={styles.p}>
          Serwis hostowany jest na infrastrukturze Railway Corp. z siedzibą w USA.
          Dane techniczne mogą być przechowywane w regionie europejskim (Amsterdam, Holandia).
          Z Railway zawarto Umowę Powierzenia Przetwarzania Danych (DPA) zawierającą Standardowe
          Klauzule Umowne (SCC) zatwierdzone przez Komisję Europejską, stanowiące podstawę prawną
          ewentualnego transferu danych do USA.
        </p>

        <h2 style={styles.h2}>8. Państwa prawa</h2>
        <p style={styles.p}>W związku z przetwarzaniem danych przysługują Państwu następujące prawa:</p>
        <ul style={styles.ul}>
          <li>Prawo dostępu do swoich danych (Art. 15 RODO)</li>
          <li>Prawo do sprostowania nieprawidłowych danych (Art. 16 RODO)</li>
          <li>Prawo do usunięcia danych (prawo do bycia zapomnianym, Art. 17 RODO) — w zakresie nie objętym obowiązkiem prawnym</li>
          <li>Prawo do ograniczenia przetwarzania (Art. 18 RODO)</li>
          <li>Prawo do przenoszenia danych (Art. 20 RODO)</li>
          <li>Prawo wniesienia sprzeciwu wobec przetwarzania (Art. 21 RODO)</li>
          <li>Prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa, www.uodo.gov.pl)</li>
        </ul>
        <p style={styles.p}>
          W celu skorzystania z powyższych praw prosimy o kontakt na adres podany w punkcie 1.
        </p>

        <h2 style={styles.h2}>9. Profilowanie i automatyczne podejmowanie decyzji</h2>
        <p style={styles.p}>
          Nie wykonujemy profilowania ani nie podejmujemy decyzji wywołujących skutki prawne
          wyłącznie w oparciu o zautomatyzowane przetwarzanie danych.
        </p>

        <h2 style={styles.h2}>10. Bezpieczeństwo danych</h2>
        <p style={styles.p}>
          Stosujemy środki techniczne i organizacyjne zapewniające ochronę danych adekwatną do
          zagrożeń, w tym: szyfrowanie transmisji (TLS/HTTPS), hashowanie haseł (bcrypt),
          kontrolę dostępu opartą na rolach, audit log wszystkich operacji, oraz okresowe
          przeglądy bezpieczeństwa.
        </p>

        <h2 style={styles.h2}>11. Zmiany Polityki Prywatności</h2>
        <p style={styles.p}>
          Niniejszą politykę możemy okresowo aktualizować. Aktualna wersja jest zawsze dostępna
          pod adresem file.mtcapital.pl/privacy. Data ostatniej aktualizacji wskazana jest na
          początku dokumentu.
        </p>
      </div>
    </div>
  );
}